<template>
    <PopupRouterViewDetail label="Putaway Header Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Putaway Header" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Putaway Header No" :model="model.putawayHeaderNo" />
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Scanned By" id="fieldset-scanned-by" size="sm" :model.sync="model.scannedByUserName"   :selected="model.scannedBy != null ? model.scannedBy.firstName : ''" @input="getUserInfos" @change="updateData" :isEditable="true" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedScannedBy" />
						<app-input-combobox-autocomplete :options="putAwayCategorys" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Putaway Category" id="fieldset-putaway-category" size="sm" :model.sync="model.putawayCategoryId"   :selected="model.putawayCategory != null ? model.putawayCategory.name : ''" @input="getPutAwayCategorys" @change="updateData" :isEditable="true" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPutawayCategory" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isEditable="true" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-input-datepicker  id="fieldset-process-date" label-cols-lg="12"  label="Process Date" size="sm" :model.sync="model.processDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="true" :isUpdatable="true"/>
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId"   :selected="model.area != null ? model.area.code : ''" @input="getAreas" @change="updateData" :isEditable="true" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import toast from '@/mixins/toastMixin';
import { required, minLength } from "vuelidate/lib/validators";
import PutawayHeader from '@/models/PutawayHeader/PutawayHeader';
import PutawayHeaderList from '@/models/PutawayHeader/PutawayHeaderList';
import PutawayHeaderFilter from '@/filters/PutawayHeader/PutawayHeaderFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin, toast],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {

			},
			filterPutawayHeader : null,
			currentPutawayHeaderPage : 1,
			putawayHeaderPageSize: 10,
			sortByPutawayHeader: '',
			sortDescPutawayHeader: '',
			userInfos: [],
			scannedBys: [],
			isScannedByComboLoading: false,
			putAwayCategorys: [],
			putawayCategorys: [],
			isPutawayCategoryComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			areas: [],
			areas: [],
			isAreaComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			usePopup: false,
			isUserInfoComboLoading: false,
			isPutAwayCategoryComboLoading: false,
			isDocumentStatusComboLoading: false,
			isAreaComboLoading: false,
		}
	},
	methods : {
		doHidden(row, modalType){
			row.toggleDetails()
			this.resetModal(modalType)
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPutawayHeader : async function(id) {
			this.isBusy = true;
			PutawayHeader.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPutawayHeader = true;
			this.filterPutawayHeader.id = this.modelId;
			PutawayHeader.downloadDataDetail(this, this.filterPutawayHeader).then(result => {
				this.isDownloadPutawayHeader = false;
			}).catch(error => { this.isDownloadPutawayHeader = false; })
		},
		getPutawayHeaders : async function(input) {
			let filter = new PutawayHeaderFilter();
			if (input != undefined) {
				filter.PutawayHeaderNo = input;
			}
			this.isPutawayHeaderComboLoading = true;
			PutawayHeader.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putawayHeaders = result.data
				}
				this.isPutawayHeaderComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedScannedBy(item) {
			if(item == undefined || item == null) {
				this.model.scannedByUserName = null;
				this.model.scannedBy = null;
			} else {
				this.model.scannedByUserName = item.userName;
				this.model.scannedBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPutAwayCategorys : async function(input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PutAwayCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putAwayCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPutawayCategory(item) {
			if(item == undefined || item == null) {
				this.model.putawayCategoryId = null;
				this.model.putawayCategory = null;
			} else {
				this.model.putawayCategoryId = item.id;
				this.model.putawayCategory = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.putawayHeaderInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				this.toast({ message: 'There are still mandatory fields that need to be filled in. Please double check your input.', title: 'Error', variant: 'danger', autoHideDelay:1500});
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PutawayHeader.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayheaderindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PutawayHeader.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayheaderindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PutawayHeader.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPutawayHeader(id);
					});
				}
			});
		},
		onHidden() {
			this.getPutawayHeaders();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}

			if(this.windowWidth <= 576) {
				this.usePopup = true
			} else {
				this.usePopup = false
			}
		},
	},
	beforeMount() {
		this.filterPutawayHeader = new PutawayHeaderFilter();
		//this.getUserInfos();
		//this.getPutAwayCategorys();
		//this.getDocumentStatuss();
		//this.getAreas();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPutawayHeader(id);
			} else {
				this.modelId = id;
				this.getPutawayHeader(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
